import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
// import Wallet from "./context/walletConnect.jsx";
import { StoreProvider } from "./context/Store.jsx";
import { NotificationProvider } from "./context/NotificationContext.jsx";
import NotificationModal from "./Components/Modals/NotificationModal.jsx";
import { ThemeProvider } from "./context/ThemeContext.jsx";
import { ThirdwebProvider } from "thirdweb/react";

const isCcipNoise = (source) =>
  typeof source === "string" && source?.includes("ccip");

window.addEventListener("error", (event) => {
  if (isCcipNoise(event?.filename) || isCcipNoise(event?.error?.stack)) {
    event?.preventDefault();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  if (isCcipNoise(event?.reason?.stack)) {
    event?.preventDefault();
  }
});

createRoot(document?.getElementById("root"))?.render(
  <BrowserRouter>
    <ThemeProvider>
      <ThirdwebProvider>
        <NotificationProvider>
          <StoreProvider>
            <App />
            <NotificationModal />
          </StoreProvider>
        </NotificationProvider >
      </ThirdwebProvider>
    </ThemeProvider>
  </BrowserRouter >
);
